// Project status options
export const PROJECT_STATUSES = [
    { value: "to_do", label: "To Do" },
    { value: "in_progress", label: "In Progress" },
    { value: "complete", label: "Complete" },
    { value: "archived", label: "Archived" },
];
// Project assignment role options
export const PROJECT_ROLES = [
    { value: "client", label: "Client" },
    { value: "contractor", label: "Contractor" },
];
